import {useLiveQuery} from 'dexie-react-hooks';
import {pendingFormAssignmentIds} from 'src/app/forms/offline/pendingFormAssignments';
import {getActiveSession} from 'src/offline/offlineSessionManager';
import {EMPTY_PENDING_ITEMS} from 'src/offline/pendingUploads';
import type {FailedOutboxItem} from 'src/offline/pendingUploads';
import {actionCreateCascade, taskTransitionCascade} from './outboxActions';
import {TASKS_CONTEXT_KEY} from './snapshotKeys';

export interface PendingTaskItems {
  /** Queued transitions, Action creates, and Assigned Form submissions. */
  pendingCount: number;
  failedItems: FailedOutboxItem[];
}

/** Live view of the task outbox, including Assigned Forms queued by the forms domain. */
export const usePendingTaskItems = (): PendingTaskItems =>
  useLiveQuery(async () => {
    const queuedForms = (await pendingFormAssignmentIds()).size;
    const session = await getActiveSession(TASKS_CONTEXT_KEY);
    if (!session) {
      return {pendingCount: queuedForms, failedItems: []};
    }
    const [transitions, creates] = await Promise.all([
      taskTransitionCascade.pendingItems(session.id),
      actionCreateCascade.pendingItems(session.id),
    ]);
    return {
      pendingCount:
        transitions.pendingCount + creates.pendingCount + queuedForms,
      failedItems: [...transitions.failedItems, ...creates.failedItems],
    };
  }, []) ?? EMPTY_PENDING_ITEMS;
